import React from "react";
import { Box, makeStyles, Theme } from "@material-ui/core";
import { colors, dateTimeFormatTimestamp } from "swyft-react-core";
import { Review } from "../api/Types";
import { TF } from "./typography/TF";

export const ReviewView: React.FC<Props> = (props: Props) => {
  const classes = useStyles();

  var stars = "";
  for (var i = 0; i < props.stars; i++) {
    stars += "★";
  }

  const maxDescriptionLength = 500;
  var description: string =
    props.full === true || props.description.length < maxDescriptionLength
      ? props.description
      : props.description.substr(0, maxDescriptionLength) + "...";

  return (
    <Box className={classes.root}>
      <TF variant="h6" bold>
        {props.name}
      </TF>
      <TF variant="subtitle1" paragraph>
        {dateTimeFormatTimestamp(props.timestamp, {
          month: "long",
          year: "numeric"
        })}
      </TF>
      <TF className={classes.stars}>{stars}</TF>
      <TF variant="h6">"{description}"</TF>
    </Box>
  );
};

type Props = {
  name: string;
  stars: number;
  description: string;
  timestamp: number;
  full?: boolean;
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(4)
  },
  stars: {
    color: colors.secondary,
    fontSize: "2em",
    letterSpacing: "0.33em"
  }
}));

const shuffle = (array: any[]) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

const sample = (array: any[], sampleSize: number = 1) => {
  if (array.length <= sampleSize) return array;
  const shuffledArray = shuffle(array);
  return shuffledArray.slice(0, sampleSize);
};

export const reviews = (amount: number = 3): Review[] => {
  return sample(allReviews, amount);
};

export const supportReviews = (amount: number = 3): Review[] => {
  return sample(allSupportReviews, amount);
};

export const solarReviews = (amount: number = 3): Review[] => {
  return sample(allSolarReviews, amount);
};

export const allReviews: Review[] = [
  {
    name: "Gareth Bastow",
    timestamp: 1640995200000,
    stars: 5,
    description:
      "What a great company to deal with and the employee’s who I spoke to, from my first phone call to arranging a survey and getting our new boiler installed by Paul who was an absolutely brilliant and explained everything. I would highly recommend Swyft, it was stress-free during what is a busy time at Xmas trying to arrange a new boiler, the communication from phone calls to emails was great, keeping us informed."
  },
  {
    name: "Aidan Hickey",
    timestamp: 1638316800000,
    stars: 5,
    description:
      "Prompt response, quick to book quotation viewing and quick to book fitting after providing a very competitive price. The fitter/technician and everyone else involved were excellent to deal with; courteous and friendly. Would highly recommend"
  },
  {
    name: "Andrew Martin",
    timestamp: 1640995200000,
    stars: 5,
    description:
      "Would recommend 100%. The customer service is excellent, they called me before the date of installation to make sure I was aware of everything and then again, a couple of weeks later to ensure that I didn’t have any issues with the new boiler. Paul came to give a quote originally and talked me through all parts of the installation and answered any questions I had and then came back to complete the job a couple of weeks later and did a great job with the boiler."
  },
  {
    name: "Siobhan Conroy",
    timestamp: 1638316800000,
    stars: 5,
    description:
      "We had our boiler replaced in October and were most impressed with them from the initial Internet service, Claire in the office to the engineers and the finished product! We were so impressed in fact that we recommended them to my parents. They are having a boiler replacement in January . Swift Seamless and So professional!!"
  }
];

export const allSupportReviews: Review[] = [
  {
    name: "Tim O’Leary",
    timestamp: 1598961600000,
    stars: 5,
    description:
      "Dealt with their Cork office recently and I was highly impressed with the professionalism and courtesy of all the staff we dealt with and the contractors also. Staff are friendly and knowledgeable and once we made our order, we did not have to lift a finger which was great. Even better was the help we received in submitting for an energy grant which got paid within a few weeks of installation. Can't praise you all enough. Highly recommend for a stress-free professional service. Thank you."
  },
  {
    name: "Andrew Shijuks",
    timestamp: 1610496000000,
    stars: 5,
    description:
      "Customer care service department is excellent. I had to call Swyft customer center a few times. They are extremely polite and helpful. Never waited more than 10 seconds to speak to someone. A real example of what customer care is. Well done guys"
  },
  {
    name: "Ann Barry",
    timestamp: 1610496000000,
    stars: 5,
    description:
      "Best value on the market, transparent pricing and easy to figure out what is best for our home. Great service, the information provided was easily accessible, office staff were so helpful, little or no disruption to our service, in and out in a day, all grant issues dealt with by Swyft and our energy bills are going down - very happy - recommended to everyone I know - thanks guys"
  }
];

export const allSolarReviews: Review[] = [
  {
    name: "Alex Estevam",
    timestamp: 1648771200000,
    stars: 5,
    description:
      "Great service from beginning to end. Got everything sorted in just one week and Des is a great professional. Couldn't recommend more!"
  },
  {
    name: "Linda Flynn",
    timestamp: 1640995200000,
    stars: 5,
    description:
      "We had Swyft install a 4kw solar array and a 5kw battery pack. Wow, very pleased with the professional workmanship, customer service and customer relations etc. The system itself is fantastic and if anything, Ciaran undersold it to us. We couldn't be happier with the solar product install or the professional manner from all of Swyft's people. I would highly recommend Swyft without a shadow of a doubt."
  },
  {
    name: "Neil Dunne",
    timestamp: 1640995200000,
    stars: 5,
    description:
      "A pleasure to deal with. Professional installation and excellent customer service pre and post installation. Highly recommended."
  },
  {
    name: "Geraldine Nolan",
    timestamp: 1643673600000,
    stars: 5,
    description:
      "Called out to do survey at a time that suited us, gave a very competitive quote. Arrived to do the job when they said they would, no mess no fuss. Delighted with the result."
  }
];
